module.exports = __webpack_public_path__ + "src/img/clockIcon.65441f57.svg";